<div class="modal-content">
  <div class="modal-header">
    <i aria-label="Close" (click)="handleClick({ close: true })" class="close pull-right align-middle fas fa-times"> </i>
    <p *ngIf="isModification" class="modal-title h4" jhiTranslate="modals.editWithConfirm.title.modification"></p>
    <p *ngIf="!isModification" class="modal-title h4" jhiTranslate="modals.editWithConfirm.title.delete"></p>
  </div>
  <div class="modal-body text-center">
    <div class="row" *ngIf="staticMessage">
      <div class="col-12">
        <div class="bary-title" [innerHTML]="staticMessage"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" *ngIf="fieldType === INPUT_MULTI_SELECT">
        <jhi-bary-input-multi-select [options]="fieldOptions" [control]="_control" [label]="label"></jhi-bary-input-multi-select>
      </div>
      <div class="col-12" *ngIf="fieldType === INPUT_TEXT">
        <jhi-bary-input-text [control]="_control" [label]="label"></jhi-bary-input-text>
      </div>
      <div class="col-12" *ngIf="fieldType === INPUT_SELECT">
        <jhi-bary-input-select [options]="fieldOptions" [control]="_control" [label]="label"></jhi-bary-input-select>
      </div>
    </div>
    <div class="row" *ngIf="_control.dirty && _control.value && hasValueDiff()">
      <div class="col-12">
        <div class="alert alert-warning" [innerHTML]="messageFn(_control.value)"></div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <jhi-bary-button (clickEvent)="handleClick({ second: true })" *ngIf="buttons.cancel" [label]="buttons.cancel" [outline]="true" class="mr-2"></jhi-bary-button>
    <jhi-bary-button
      *ngIf="buttons.submit"
      [block]="!buttons.cancel"
      color="primary"
      [label]="buttons.submit"
      [disabled]="(!_control.dirty || !_control.value || !hasValueDiff()) && !enableSubmitBtn"
      (clickEvent)="handleClick({ submit: true, value: _control.value })"
    ></jhi-bary-button>
  </div>
</div>
